// image-radius-fix.js
// Erzwingt dauerhaft abgerundete Ecken bei "Image with text"-Bildern, unabhängig davon,
// was sie sonst noch zurücksetzt (z.B. lazysizes nach dem Laden). Läuft laufend im
// Hintergrund und stellt die Rundung bei jeder DOM-Änderung wieder her.
(function () {
  function applyRadius() {
    document.querySelectorAll('.image-content__image, .image-content__image-wrapper, .image-content__image-container').forEach(function (el) {
      el.style.setProperty('border-radius', '20px', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    });
  }
  applyRadius();
  window.addEventListener('load', applyRadius);
  document.addEventListener('lazyloaded', applyRadius);
  setTimeout(applyRadius, 500);
  setTimeout(applyRadius, 1500);
  setTimeout(applyRadius, 3000);
  var mo = new MutationObserver(function () { applyRadius(); });
  mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
})();
